import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tip"]
const _hoisted_2 = { class: "label-text pr-5" }


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsOption',
  props: {
    label: {},
    tooltip: {},
    labelClass: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-control w-full", _ctx.tooltip != undefined && _ctx.tooltip != '' ? 'tooltip' : '']),
    "data-tip": _ctx.tooltip
  }, [
    _createElementVNode("label", {
      class: _normalizeClass(["label cursor-pointer", _ctx.labelClass ?? ''])
    }, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 10, _hoisted_1))
}
}

})